import {traceId} from './uuid';

const KEY = 'TP-Trace-Id';
const TIMEOUT_1_HOUR_IN_MS = 60 * 60 * 1000;

function serialize(enabled: boolean = true, id: string, ts: string | number) {
    return `${enabled ? '1' : '0'}:${id}:${ts}`;
}

function deserialize(stored: string) {
    const [enabled, uuid, ts] = stored.split(':');
    return {
        enabled: enabled === '1',
        uuid,
        ts: parseInt(ts, 10),
    };
}

function notTimeoutOut(ts: number, now: number) {
    return ts && !(now > (ts + TIMEOUT_1_HOUR_IN_MS));
}

export function getTraceId(now: number = Date.now()) {
    try {
        const str = localStorage.getItem(KEY);
        if (str) {
            const state = deserialize(str);
            if (state.enabled && notTimeoutOut(state.ts, now)) {
                return state.uuid;
            }
        }
    } catch (e) {
        // ignore
    }
}

export function setTraceId(overrideEnabled: boolean, overrideTraceId?: string, now: number = Date.now()) {
    try {

        const str = localStorage.getItem(KEY);
        if (str) {
            const state = deserialize(str);
            const nextEnabledState = typeof overrideEnabled !== 'undefined' ? overrideEnabled : state.enabled;
            const id = overrideTraceId || state.uuid || traceId();
            localStorage.setItem(KEY, serialize(nextEnabledState, id, now));
            return id;
        } else {
            const id = overrideTraceId || traceId();
            localStorage.setItem(KEY, serialize(overrideEnabled, id, now));
            return id;
        }
    } catch (e) {
        // ignore
    }
}
